/**
 * @fileoverview Sales role codes.
 * @description The roles the backend lets carry a reporting manager, and the only roles a user can be invited or reactivated as. Shared so Invite/Add User and Reactivate User read one list instead of each keeping its own copy.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

/** The Sales roles: the ones that take a reporting manager, and that a user may be reactivated as. */
export const SALES_ROLE_CODES: ReadonlySet<string> = new Set([
  'SALES_HEAD',
  'SALES_MANAGER',
  'SALES_EXECUTIVE',
])
